module.exports = __webpack_public_path__ + "static/media/traffic-moderate.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/traffic-moderate.svg
// module id = 922
// module chunks = 0